import React, { useEffect, useState } from "react";

const BRIDGES = [
  // User-provided George Washington Bridge photo (blue-hour, illuminated cables, Manhattan skyline)
  "https://customer-assets-eiarnc6j.emergentagent.net/job_cross-columbia/artifacts/pg7t9do5_Document.jpeg",
];

const INTERVAL_MS = 6500;

/**
 * BridgeSlideshow
 *  Crossfading full-bleed slideshow of iconic bridges with slow Ken Burns
 *  zoom. A strong teal overlay sits on top to keep white serif headlines
 *  legible and tint the photos into the palette.
 */
export default function BridgeSlideshow() {
  const [active, setActive] = useState(0);

  // Preload
  useEffect(() => {
    BRIDGES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setActive((i) => (i + 1) % BRIDGES.length);
    }, INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
      {BRIDGES.map((src, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-[2000ms] ease-out"
          style={{ opacity: i === active ? 1 : 0 }}
        >
          <div
            className="absolute inset-0 bg-center bg-cover will-change-transform"
            style={{
              backgroundImage: `url('${src}')`,
              animation:
                i === active
                  ? "kenburns 14s ease-in-out both"
                  : "none",
            }}
          />
        </div>
      ))}

      {/* Teal tint + vignette overlays */}
      <div className="absolute inset-0 bg-[#0a3d5e]/70" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a3d5e]/50 via-[#0a3d5e]/40 to-[#0a3d5e]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a3d5e]/80 via-transparent to-[#0a3d5e]/40" />
    </div>
  );
}
